export const MINUTE = 60 * 1000
export const HOUR = MINUTE * 60
export const DAY = HOUR * 24
export const WEEK = DAY * 7
export const MONTH = DAY * (365 / 12)
export const YEAR = DAY * 365
